<template>
  <v-btn
    text
    dark
    :loading="loading"
    :disabled="disabled || loading"
    @click="analizar"
  >
    CUOTAS NO PAGADAS
    <v-icon right color="white">fas fa-search</v-icon>
  </v-btn>
</template>
<template>
  <v-btn
    text
    dark
    :loading="loading"
    :disabled="disabled || loading"
    @click="analizar"
  >
    CUOTAS NO PAGADAS
    <v-icon right color="white">fas fa-search</v-icon>
  </v-btn>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AnalizadorBtn',
  props: {
    // FormularioPlanPagoId / numeroCaso
    numeroCaso: { type: [String, Number], required: true },
    carnet: { type: String, required: true },
    cicloActual: { type: String, required: true },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      _lock: false
    }
  },
  methods: {
    // MISMA lógica del Formulario: corta hasta (cuota==1 && periodoLectivo==cicloActual)
    recortarHastaMatriculaActual(res) {
      const out = []
      for (let i = 0; i < res.length; i++) {
        const el = res[i]
        out.push(el)
        if (Number(el.cuota) === 1 && el.periodoLectivo === this.cicloActual) {
          break
        }
      }
      return out
    },

    async analizar() {
      if (this._lock) return
      this._lock = true
      this.loading = true

      try {
        // 1) Traer cuotas NO pagadas (mismo endpoint que usa el FormularioPlanPagos)
        const cuotasResp = await axios.get(
          `api/Contrato/Cuotas?Carnet=${encodeURIComponent(this.carnet)}&Facturado=false`
        )
        const cuotas = Array.isArray(cuotasResp.data) ? cuotasResp.data : []

        // Recorte igual al formulario
        const recorte = this.recortarHastaMatriculaActual(cuotas)

        if (recorte.length === 0) {
          this.$emit('done', { inserted: 0, message: 'No hay cuotas impagas para insertar.' })
          return
        }

        // 2) Traer detalles actuales del plan (para evitar duplicados)
        const detResp = await axios.get(
          `api/FormularioPlanPago/${this.numeroCaso}/DetallePlanPago`
        )
        const detalles = Array.isArray(detResp.data) ? detResp.data : []
        const existentes = new Set(detalles.map(d => d.npe))

        // 3) Faltantes (impagas pero no existentes en DetallePlanPago)
        const seen = new Set()
        const faltantes = []
        for (const c of recorte) {
          if (!c || !c.npe) continue
          if (seen.has(c.npe)) continue
          seen.add(c.npe)

          if (!existentes.has(c.npe)) {
            faltantes.push(c)
          }
        }

        if (faltantes.length === 0) {
          this.$emit('done', { inserted: 0, message: 'Ya estaban insertadas todas las cuotas impagas.' })
          return
        }

        // 4) Payload igual al formulario (pero aquí fechaPago = null como pediste)
        //    OJO: montoPago numérico para evitar problemas de validación
        const payload = faltantes.map(c => ({
          npe: c.npe,
          montoPago: Number(c.monto),
          fechaPago: null
        }))

        // 5) 1 solo POST bulk
        await axios.post(
          `api/FormularioPlanPago/${this.numeroCaso}/DetallePlanPago`,
          payload
        )

        // 6) Notificar y refrescar
        this.$emit('done', { inserted: faltantes.length })
        this.$emit('refresh') // el padre llama getDetalles()
      } catch (err) {
        this.$emit('error', err)
      } finally {
        this.loading = false
        this._lock = false
      }
    }
  }
}
</script>
